import { RcFile } from 'antd/lib/upload';
import { InvoiceSpreadsheet } from '.';

export const importInvoicesSpreadsheet = async (
  file: RcFile,
): Promise<InvoiceSpreadsheet[]> => {
  // XLSX (sheets.js) is enormous and shouldn't be imported normally
  return import('xlsx').then(async (xlsx) => {
    const wb = xlsx.read(await file.arrayBuffer());
    const sheetNames = wb.SheetNames;
    const sheets: InvoiceSpreadsheet[] = [];
    for (const sheetName of sheetNames) {
      sheets.push({
        name: sheetName,
        rows: xlsx.utils.sheet_to_json(wb.Sheets[sheetName], {
          header: 'A', // Use literal column labels for row object keys for spreadsheet preview
          raw: false, // To read numbers as strings
        }),
      });
    }
    return sheets;
  });
};
